import SectionHead from "./SectionHead";
import { newArrivals } from "@/mocks/homeContent";

export default function NewArrivals() {
  return (
    <section id="newin" className="w-full scroll-mt-24 bg-[#f9f4e9]">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-3">
          {/* left rail: heading + update note */}
          <div className="lg:col-span-1">
            <SectionHead
              eyebrow="FRESH SHELVED · 新入库"
              title="最近整理了什么"
              desc="新料老料都在按计划归档，这里能看到最近的入库与整理动态，时不时回来翻一眼总有新东西。"
            />
            <div className="mt-8 rounded-xl border border-[#ded2bb] bg-[#f1e9d7] p-5">
              <div className="flex items-center gap-2 text-[#201b15]">
                <i className="ri-refresh-line text-lg" aria-hidden="true" />
                <span className="text-sm font-bold">入库节奏</span>
              </div>
              <ul className="mt-3 space-y-2.5 text-[13px] leading-relaxed text-[#6d6149]">
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-[#a1762f]" aria-hidden="true" />
                  每周固定补录热门新料
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-[#a1762f]" aria-hidden="true" />
                  不定期把冷门老料重新归位
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-checkbox-circle-fill mt-0.5 text-[#a1762f]" aria-hidden="true" />
                  节假日加更年度盘点合集
                </li>
              </ul>
            </div>
          </div>

          {/* right timeline */}
          <div className="lg:col-span-2">
            <ol className="relative border-l border-[#dccdae] pl-6 md:pl-8">
              {newArrivals.map((n, i) => (
                <li key={n.date} className="relative pb-8 last:pb-0">
                  <span
                    className="absolute -left-[31px] top-1.5 h-2.5 w-2.5 rounded-full ring-4 ring-[#f9f4e9]"
                    style={{ background: n.isNew ? '#c8962f' : '#d9c9a8' }}
                    aria-hidden="true"
                  />
                  <div className="flex flex-wrap items-center gap-2 md:gap-3">
                    <span className="font-editorial text-sm italic text-[#b3873a]">
                      {n.date}
                    </span>
                    <span className="whitespace-nowrap rounded-md bg-[#f3e9d2] px-2 py-0.5 text-[11px] font-semibold text-[#a1762f]">
                      {n.type}
                    </span>
                    {n.isNew && (
                      <span className="flex items-center gap-1 rounded-full bg-[#201b15] px-2 py-0.5 text-[10px] font-bold tracking-wider text-[#e9c579]">
                        <i className="ri-sparkling-2-fill text-[10px]" aria-hidden="true" />
                        NEW
                      </span>
                    )}
                  </div>
                  <h4 className="mt-2 text-[17px] font-bold text-[#241f18]">{n.title}</h4>
                  <p className="mt-1 text-[13px] leading-relaxed text-[#6d6149]">{n.desc}</p>
                  {i !== newArrivals.length - 1 && (
                    <div className="mt-4 hidden h-px w-full bg-[#ece2cd] sm:block" aria-hidden="true" />
                  )}
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}